module.exports = __webpack_public_path__ + "static/img/hzdw3.91abaa24.png";